<script>
export default {
    props: [
        'cancellationNames',
        'potentialNames',
        'submitError',
        'disableCancellation',
        'passenger'
    ],
    data() {
        return {
          email:'',
          mobile: window.innerWidth <= 700,
        };
    },
    created() {
    addEventListener("resize", () => {
          this.mobile = innerWidth <= 700;
        });
  },
    mounted() {
      this.email = this.passenger.email
    },
    methods: {
      onSubmit() {
        if (this.email !== '' && this.validateEmail(this.email) || this.email !== '' && this.passenger.email.includes('*')) {
          this.$emit('submitCancellation', this.passenger.email.includes('*') ? this.passenger.email : this.email)
        }
      },
      validateEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
      }
    }
}
</script>
<template>
  <span>
    <div v-if="!submitError">
      <div class="row-fluid text-center justifiy-content-center">
        <p>
          Please check the details below and proceed.
        </p>
        <p>
          Cancellation Notification for:
        </p>
        <p
          v-for="(pax, index) in cancellationNames"
          :key="index"
          style="color: #76c95f; font-weight:600;"
        >
          {{ pax.value ? pax.value : pax }}
        </p>
        <p v-if="potentialNames && potentialNames.length">
          Other people on this booking who are intending on cancelling:
        </p>
        <span v-if="potentialNames && potentialNames.length">
          <p
            v-for="(pax, index) in potentialNames"
            :key="index"
            style="color: grey; font-weight:600;"
          >
            {{ pax.value ? pax.value : pax }}
          </p></span>
      </div>

      <div class="row justify-content-center">
        <b-form-group
          label="Email Address"
          label-for="input-cancellation-email"
          :class="mobile ? 'vtd-form-group w-100 pl-2 pr-2' : 'vtd-form-group w-50 pl-2 pr-2'"
        >
          <b-form-input
            v-model="email"
            type="email"
            placeholder="Enter email"
            :disabled="passenger.email.includes('*') ? true : false"
            :class="validateEmail(email) || passenger.email.includes('*') ? '' : 'required-input'"
          />
        </b-form-group>
      </div>

      <div class="row justify-content-center ">
        <button
          block
          :disabled="disableCancellation"
          class="btn btn-success rounded"
          @click="onSubmit" 
        >
          Submit & Complete Cancellation Notification
        </button>
      </div>
    </div>
  
    <div v-if="submitError">
      <div class="row-fluid text-center justifiy-content-center">
        <b-alert
          variant="danger"
          show
        >There has been an error submitting your form. Please contact your Travel Consultant for assistance.</b-alert>
      </div>
    </div>
    
  </span>
</template>